export class PayMethod {
    Method;
    Autopay;
    BankCode;
    BankAcNum;
    BankFileType;
    constructor() {
        {
            this.Method = "";
            this.Autopay = false;
            this.BankCode = "";
            this.BankAcNum = "";
            this.BankFileType = ""
        }

    }
}



// WEBPACK FOOTER //
// ./src/model/PayMethod.js